var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgTimeoffTriangle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 5,
    viewBox: "0 0 7 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.303399 1.1909C0.121344 0.995224 0.250283 0.660645 0.507747 0.660645H5.92398C6.18144 0.660645 6.31038 0.995224 6.12833 1.1909L3.42021 4.10167C3.30735 4.22298 3.12437 4.22298 3.01151 4.10167L0.303399 1.1909Z",
    fill: "#8A3FFC"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgTimeoffTriangle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/timeoff-triangle.436365ea03d06c849bf96d484a9866b4.svg";